import {
  HELP_TTS_LANG,
  HELP_TTS_RATE,
  isPortugueseVoice,
  pickLockedWebVoice,
} from "../config/helpTtsVoiceConfig";

export const HELP_TTS_SAMPLE_TEXT =
  "Olá. Esta é uma amostra da voz selecionada para ler as explicações de ajuda no Agriconnected.";

export function isHelpSpeechSupported() {
  return (
    typeof window !== "undefined" &&
    "speechSynthesis" in window &&
    typeof window.SpeechSynthesisUtterance !== "undefined"
  );
}

let cachedVoice = null;

function refreshCachedVoice() {
  if (!isHelpSpeechSupported()) {
    cachedVoice = null;
    return;
  }
  cachedVoice = pickLockedWebVoice(window.speechSynthesis.getVoices());
}

export function ensureHelpVoicesLoaded(onReady) {
  if (!isHelpSpeechSupported()) {
    onReady();
    return () => {};
  }

  const sync = () => {
    refreshCachedVoice();
    onReady();
  };

  sync();

  if (window.speechSynthesis.getVoices().length === 0) {
    window.speechSynthesis.addEventListener("voiceschanged", sync);
    return () => {
      window.speechSynthesis.removeEventListener("voiceschanged", sync);
    };
  }

  return () => {};
}

export function getLockedHelpVoice() {
  if (!cachedVoice && isHelpSpeechSupported()) {
    refreshCachedVoice();
  }
  return cachedVoice;
}

export function stopHelpSpeech() {
  if (!isHelpSpeechSupported()) return;
  window.speechSynthesis.cancel();
}

export function speakHelpText(text, callbacks = {}) {
  if (!isHelpSpeechSupported()) return false;

  const normalized = (text || "").replace(/\s+/g, " ").trim();
  if (!normalized) return false;

  stopHelpSpeech();

  const utterance = new window.SpeechSynthesisUtterance(normalized);
  utterance.lang = HELP_TTS_LANG;
  utterance.rate = HELP_TTS_RATE;

  const voice = getLockedHelpVoice();
  if (voice) {
    utterance.voice = voice;
    utterance.lang = voice.lang || HELP_TTS_LANG;
  }

  utterance.onstart = () => {
    if (callbacks.onStart) callbacks.onStart();
  };
  utterance.onend = () => {
    if (callbacks.onEnd) callbacks.onEnd();
  };
  utterance.onerror = () => {
    if (callbacks.onError) callbacks.onError();
  };

  window.speechSynthesis.speak(utterance);
  return true;
}

export function loadHelpVoices(onVoicesLoaded) {
  if (!isHelpSpeechSupported()) {
    onVoicesLoaded([]);
    return () => {};
  }

  const readVoices = () => {
    onVoicesLoaded(
      window.speechSynthesis.getVoices().filter(isPortugueseVoice)
    );
  };

  readVoices();

  if (window.speechSynthesis.getVoices().length === 0) {
    window.speechSynthesis.addEventListener("voiceschanged", readVoices);
    return () => {
      window.speechSynthesis.removeEventListener("voiceschanged", readVoices);
    };
  }

  return () => {};
}

export { isPortugueseVoice, pickLockedWebVoice };
